module.exports = __webpack_public_path__ + "static/media/icon_select3.da8f8494.svg";